<p>save-team-dialog works!</p>
